import { RgbColor } from '~/shared';
import { createSlice } from '../wrappers';

const initialState = {
	selectedColor: [
		{ r: 255, g: 255, b: 255 },
		{ r: 255, g: 255, b: 255 },
	] as [RgbColor, RgbColor],
	sectionIndex: 0,
};

const colorPickerSlice = createSlice({
	name: 'colorPicker',
	initialState,
	reducers: {
		setSelectedColor: (state, action) => {
			const { selectedColor } = state;
			const colorSection = state.sectionIndex;
			selectedColor[colorSection] = action.payload;
			state.selectedColor = selectedColor;
		},
		setSectionIndex: (state, action) => {
			// console.log(action.payload);
			state.sectionIndex = action.payload;
		},
	},
});

export const { setSelectedColor, setSectionIndex } = colorPickerSlice.actions;

export default colorPickerSlice.reducer;
